module.exports = __webpack_public_path__ + "static/media/immobilized.860479de.png";